/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-21 21:02:17
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyWidget } from "../BsyWidget";
import "./index.css";

import { BsyConfig } from "../../global/BsyConfig";
import BsySelect from "../BsySelect";
import BsyIconBtn from "../BsyIconBtn";
import { BsyUtils } from "../../utils/Utils";
import { BsyFilterApp } from "../filterField/BsyFilterApp";
import { BsyFilterEntry } from "../filterField/BsyFilterEntry";

export default class BsyDataLoadFilterPane extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-filter-pane",
    fields: [],
    hasMethods: !0,
    hasRelation: !1,
    hasFlowFilters: !1,
    onStopEdit: null,
    modal: !0,
    hasPin: false,
    hasHeader: false,
    filterSticky: false,
    filterTopSticky: false,
    hasfilterSticky: true,
    hasfilterTopSticky: true,
    rel: "and",
    hasSticky: false,
    cond: [],
  };
  constructor(props) {
    super(props);
    this.element = React.createRef();
    this.contextMap = {};
    this.filter = {};
    this.filterMap = {};

    this.state = {
      availableFields: BsyConfig().LimitFields.filter,
      text4add: React.language("field.linkFilter.add"),
      ...props,
    };
  }

  componentDidMount() {
    this._initFilter();
  }

  getContext = (e) => {
    this.contextMap[e.options.widgetId] = e;
  };

  getValue = () => {
    const { rel, cond, appId, entryId } = this.state;
    return {
      rel,
      cond,
      appId,
      entryId,
    };
  };

  deleteFilterItem = (res) => {
    const { fields } = this.state;
    let cond = [];
    const newFields = fields.filter((d) => {
      let ret = d.name !== res.widgetId;
      if (!ret) {
        if (this.filterMap[res.widgetId]) delete this.filterMap[res.widgetId];
        if (this.filter[res.widgetId]) {
          delete this.filter[res.widgetId];
        }
        if (this.contextMap[res.widgetId]) {
          delete this.contextMap[res.widgetId];
        }
      } else {
        if (this.filter[d.name]) {
          cond.push(this.filter[d.name]);
        }
      }
      return ret;
    });
    this.setState(
      {
        fields: newFields,
        cond: cond,
      },
      () => {
        // this.props.onSetFieldFilter && this.props.onSetFieldFilter(this.getValue());
        this.props.onFilter &&
          this.props.onSetFieldFilter(
            {
              rel: this.state.rel,
              cond: [...cond],
              appId: this.state.appId,
              entryId: this.state.entryId,
            },
            true
          );
      }
    );
  };

  _getComboCheckFilter = (t, e) => {
    let i = (e && e.items) || (e && e.value);
    let r = {
      type: t,
      hasEmpty: !!e?.hasEmpty,
      value: !BsyUtils.isObjectEmpty(i) ? BsyUtils.makeArray(i) : [],
      hasCurrentDept: !(!e || !e.hasCurrentDept),
      hasCurrentUser: !(!e || !e.hasCurrentUser),
      hasCurrentSubDept: !(!e || !e.hasCurrentSubDept),
      hasCurrentParDept: !(!e || !e.hasCurrentParDept),
    };
    if (e) {
      r.parentDepts = e.parentDepts ? BsyUtils.makeArray(e.parentDepts) : [];
    }
    switch (r.type) {
      case "flow_chargers":
      case "user":
      case "usergroup": {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        break;
      }
      case "deptgroup":
      case "dept": {
        delete r.hasCurrentUser;
        break;
      }
      default: {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        delete r.parentDepts;
        delete r.hasCurrentUser;
        break;
      }
    }
    return r;
  };

  _initFilter = () => {
    let { fields } = this.state,
      e = this;

    this.filter = {};
    BsyUtils.forEach(fields, function (t1, i) {
      if (!i || !i.widgetId) {
        return true;
      }

      let a = i.fields[0];
      let t = a.field;
      let n = {
        entryId: a.form,
        field: a.field,
        triggers: i.triggers,
        rely: i.rely,
      };

      if (a.subform) {
        n = {
          ...n,
          ...{
            subform: a.subform,
            subField: a.subField,
          },
        };
      }

      e.filter[t] = n;

      let valueMode = i.valueMode;
      let method = i.method;
      if (valueMode == "input") {
        if (!i.defaultConfig || !i.defaultConfig.value) {
          i.method = "empty";
        } else {
          if (a.likeMatch === true) {
            i.method = "like";
          } else i.method = "eq";
        }
      }
      if (i.type === "number_filter" && !BsyUtils.isObjectEmpty(i.tick)) {
        let tickValue = i.tickValue;
        let a = i.defaultConfig;
        if (method === "range") {
          if (tickValue && a) {
            if (a.min) {
              switch (tickValue.min) {
                case "hour": {
                  a.min = a.min * 60 * 60;
                  break;
                }
                case "days": {
                  a.min = a.min * 60 * 60 * 24;
                  break;
                }
                case "minute":
                default: {
                  a.min = a.min * 60;
                  break;
                }
              }
            }
            if (a.max) {
              switch (tickValue.max) {
                case "hour": {
                  a.max = a.max * 60 * 60;
                  break;
                }
                case "days": {
                  a.max = a.max * 60 * 60 * 24;
                  break;
                }
                case "minute":
                default: {
                  a.max = a.max * 60;
                  break;
                }
              }
            }
          }
        } else {
          if (a && a.value) {
            switch (tickValue) {
              case "hour": {
                a.value = a.value * 60 * 60;
                break;
              }
              case "days": {
                a.value = a.value * 60 * 60 * 24;
                break;
              }
              case "minute":
              default: {
                a.value = a.value * 60;
                break;
              }
            }
          }
        }
      }
      e._updateFilter(t, i, i.defaultConfig);
    });
    this.onSetFieldFilter();
  };
  _updateFilter = (t, e, i) => {
    let a = e.fields[0],
      n = {};
    this.filter[t] = this.filter[t] || {};
    n.method = e.method || BsyUtils.getDashDefaultFilterMethod(a && a.type);
    n.value = i;
    n.valueMode = e.valueMode;
    n.fields = e.fields;
    n.field = t;
    n.entryId = e.entryId || a.form;
    n.hasEmpty = n.method === "empty";
    if (a) {
      switch (a.type) {
        case "text":
        case "radiogroup":
        case "combo":
        case "sn":
          n = { ...n, ...this._getComboCheckFilter("text", i) };
          break;
        case "textarea":
          n.type = "textarea";
          let s = i && i.items ? i.items[0] : i && i.value;
          n.value = s ? BsyUtils.makeArray(s) : [];
          break;
        case "combocheck":
        case "checkboxgroup":
          n = { ...n, ...this._getComboCheckFilter("combocheck", i) };
          break;
        case "number":
          n.type = "number";
          if (n.method === "empty" || n.method === "not_empty") {
            n.value = [];
          } else {
            i &&
              (n.value = BsyUtils.isEmpty(i.value)
                ? [i.min, i.max]
                : [i.value]);
          }
          break;
        case "datetime":
          n.type = "datetime";
          let o = "yyyy-MM-dd";
          switch (e.type) {
            case "datetime_filter": {
              o = "yyyy-MM-dd HH:mm:ss";

              break;
            }
            case "datemonth_filter": {
              o = "yyyy-MM";
              break;
            }
            case "dateyear_filter": {
              o = "yyyy";
              break;
            }
            default:
          }
          // let o = "datetime_filter" === e.type ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd";
          // i && i.value ? n.value = [BsyUtils.date2Str(new Date(i.value), o)] : i && i.mode ? n.value = [i] : n.value = [i && i.min ? BsyUtils.date2Str(new Date(i.min), o) : null, i && i.max ? BsyUtils.date2Str(new Date(i.max), o) : null];
          n.valueMode = undefined;
          n.hasEmpty = undefined;
          if (i && i.value) {
            n.value = [typeof i.value === 'string' ? i.value : BsyUtils.date2Str(new Date(i.value), o)];
          } else {
            if (i && i.mode) {
              n.value = i;
            } else {
              n.value = [
                i && i.min ? typeof i.min === 'string' ? i.min : BsyUtils.date2Str(new Date(i.min), o) : null,
                i && i.max ? typeof i.max === 'string' ? i.max : BsyUtils.date2Str(new Date(i.max), o) : null,
              ];
            }
          }

          break;
        case "address":
        case "location":
          n.type = "address";
          n.value = i ? [i.province, i.city, i.district] : [];
          break;
        case "user":
        case "usergroup":
        case "dept":
        case "deptgroup":
        case "flowcreator":
          n = { ...n, ...this._getComboCheckFilter(a.type, i) };
          break;
        case "flow_chargers":
          n.type = "flow_chargers";
          n = { ...n, ...this._getComboCheckFilter(a.type, i) };
          break;
        case "flowstate":
        case "flowState":
          n.type = "flowstate";
          let e1 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e1) ? BsyUtils.makeArray(e1) : [];
          break;
        case "flowdecision":
          n.type = "flowdecision";
          let e2 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e2) ? BsyUtils.makeArray(e2) : [];
          break;
        case "backflowid":
          n.type = "backflowid";
          n.value = i;
          break;
        case "flownode":
          n.type = "flownode";
          n.value = i;
          break;
        case "upload":
        case "image":
          n.type = a.type;
          n.value = [];
          break;
        case "signature":
          n.type = "signature";
          n.value = [];
          break;
        case "assist_prostatus":
          n.type = "assist_prostatus";
          let e4 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e4) ? BsyUtils.makeArray(e4) : [];
          break;
        case "assist_flowid":
          n.type = "assist_flowid";
          let e3 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e3) ? BsyUtils.makeArray(e3) : [];
          break;
        default:
          break;
      }
    }
    this.filter[t] = { ...this.filter[t], ...n };
  };

  onFilterStopEdit = (t, e) => {
    let a = t.value;
    let valueMode = t.valueMode;
    let method = t.method;
    if (valueMode === "input") {
      if (!a || !a.value) {
        method = "empty";
      } else {
        if (a.likeMatch === true) {
          method = "like";
        } else method = "eq";
      }
    }

    if (
      a &&
      method !== "empty" &&
      method !== "not_empty" &&
      e.type === "number_filter" &&
      !BsyUtils.isObjectEmpty(e.tick)
    ) {
      var tickValue = t.tickValue;
      a.tickValue = t.tickValue;
      if (method === "range") {
        if (tickValue && a) {
          if (a.min) {
            switch (tickValue.min) {
              case "hour": {
                a.min = a.min * 60 * 60;
                break;
              }
              case "days": {
                a.min = a.min * 60 * 60 * 24;
                break;
              }
              case "minute":
              default: {
                a.min = a.min * 60;
                break;
              }
            }
          }
          if (a.max) {
            switch (tickValue.max) {
              case "hour": {
                a.max = a.max * 60 * 60;
                break;
              }
              case "days": {
                a.max = a.max * 60 * 60 * 24;
                break;
              }
              case "minute":
              default: {
                a.max = a.max * 60;
                break;
              }
            }
          }
        }
      } else {
        if (a && a.value) {
          switch (tickValue) {
            case "hour": {
              a.value = a.value * 60 * 60;
              break;
            }
            case "days": {
              a.value = a.value * 60 * 60 * 24;
              break;
            }
            case "minute":
            default: {
              a.value = a.value * 60;
              break;
            }
          }
        }
      }
    }

    this._updateFilter(
      e.widgetId,
      {
        ...e,
        ...{
          entryId: e.fields[0].form,
          method: method,
        },
      },
      a
    );

    this.onSetFieldFilter();
  };

  onSetFieldFilter = () => {
    const d = Object.entries(this.filter).map((it) => {
      return it[1];
    });

    this.setState(
      {
        cond: JSON.parse(JSON.stringify(d)),
      },
      () => {
        // that.props.onSetFieldFilter && that.props.onSetFieldFilter(this.getValue());
        // console.log('d2222', JSON.stringify(this.state.cond))
        this.props.onFilter &&
          this.props.onSetFieldFilter(
            {
              rel: this.state.rel,
              cond: [...this.state.cond],
            },
            true
          );
      }
    );
  };

  //转换默认值的格式
  _margedefaultConfig = (filter, defaultConfig) => {
    if (!filter || !BsyUtils.checkFilterValid(filter)) {
      return {};
    }
    let filterType = BsyUtils._widget_dash_filter(filter.type);
    switch (filterType) {
      case "backflowid_filter":
      case "flownode_filter": {
        return {
          value: filter.value,
        };
        break;
      }
      case "flowcreator_filter":
      case "dept_filter":
      case "user_filter":
      case "text_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.LK:
          case BsyConfig().CONST.FILTER_METHOD.ULK:
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE: {
            return {
              value: filter.value[0],
              likeMatch: defaultConfig ? defaultConfig.likeMatch : undefined,
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.IN:
          case BsyConfig().CONST.FILTER_METHOD.NIN: {
            return {
              parentDepts: filter.parentDepts ? filter.parentDepts : [],
              hasCurrentDept: filter.hasCurrentDept
                ? filter.hasCurrentDept
                : false,
              hasCurrentParDept: filter.hasCurrentParDept
                ? filter.hasCurrentParDept
                : false,
              hasCurrentSubDept: filter.hasCurrentSubDept
                ? filter.hasCurrentSubDept
                : false,
              hasCurrentUser: filter.hasCurrentUser
                ? filter.hasCurrentUser
                : false,
              hasEmpty: filter.hasEmpty ? filter.hasEmpty : false,
              items: [...filter.value],
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.EP: {
            return {
              value: "",
              likeMatch: defaultConfig ? defaultConfig.likeMatch : undefined,
            };
            break;
          }
          default:
        }
        break;
      }
      case "textarea_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.LK:
          case BsyConfig().CONST.FILTER_METHOD.ULK: {
            return {
              value: filter.value[0],
            };
            break;
          }
          default:
        }
        break;
      }
      case "number_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE:
          case BsyConfig().CONST.FILTER_METHOD.GT:
          case BsyConfig().CONST.FILTER_METHOD.GTE:
          case BsyConfig().CONST.FILTER_METHOD.LT:
          case BsyConfig().CONST.FILTER_METHOD.LTE: {
            return {
              value: filter.value[0],
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.RG: {
            return {
              min: filter.value[0],
              max: filter.value[1],
            };
            break;
          }
          default:
        }
        break;
      }
      case "flowdecision_filter": {
        if (filter && filter.value) {
          return {
            value: filter.value,
          };
        }
        break;
      }

      case "usergroup_filter":
      case "deptgroup_filter":
      case "flow_chargers_filter":
      case "combocheck_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.ALL:
          case BsyConfig().CONST.FILTER_METHOD.IN: {
            return {
              parentDepts: filter.parentDepts ? filter.parentDepts : [],
              hasCurrentDept: filter.hasCurrentDept
                ? filter.hasCurrentDept
                : false,
              hasCurrentParDept: filter.hasCurrentParDept
                ? filter.hasCurrentParDept
                : false,
              hasCurrentSubDept: filter.hasCurrentSubDept
                ? filter.hasCurrentSubDept
                : false,
              hasCurrentUser: filter.hasCurrentUser
                ? filter.hasCurrentUser
                : false,
              hasEmpty: filter.hasEmpty ? filter.hasEmpty : false,

              items: [...filter.value],
            };
            break;
          }
          default:
        }
        break;
      }
      case "date_filter":
      case "datetime_filter":
      case "datemonth_filter":
      case "dateyear_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE:
          case BsyConfig().CONST.FILTER_METHOD.GTE:
          case BsyConfig().CONST.FILTER_METHOD.LTE: {
            return {
              value: filter.value[0]
                ? filter.value[0]
                : null,
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.RG: {
            return {
              min: filter.value[0] ? filter.value[0]: null,
              max: filter.value[1] ? filter.value[1] : null,
            };
            break;
          }
          case BsyConfig().CONST.FILTER_METHOD.FM: {
            return filter.value;
            break;
          }
          default:
        }
        break;
      }

      case "location_filter":
      case "address_filter":
      case "address_province_filter":
      case "address_city_filter":
      case "address_district_filter":
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.ALL:
          case BsyConfig().CONST.FILTER_METHOD.NIN: {
            return {
              province: filter.value[0],
              city: filter.value[1],
              district: filter.value[2],
            };
            break;
          }
          default:
        }
        break;
      default: {
        if (filter && filter.value) {
          return {
            value: filter.value[0],
          };
        }
        break;
      }
    }
  };

  //重置条件值
  reset = () => {
    let that = this;
    // BsyUtils.forEach(this.filter, (key, res) => {
    //     // delete this.filterMap[key].defaultConfig;
    //     res.value = null;
    //     res.hasCurrentDept = false;
    //     res.hasCurrentParDept = false;
    //     res.hasCurrentSubDept = false;
    //     res.hasCurrentUser = false;
    //     res.hasEmpty = false;
    //     res.parentDepts = [];
    //     dda.push(res);
    //     that.contextMap[key].setValue(null, res.method);
    // })
    // let d = [];
    // BsyUtils.forEach(this.state.fields, (index, data) => {
    //     if (data && that.filter[data.widgetId || data.name])
    //         d.push(that.filter[data.widgetId || data.name]);
    // })
    this.entryIdCC++;
    this.appIdCC++;
    this.filter = {};
    that.setState(
      {
        cond: [],
        fields: [],
      },
      () => {
        this.props.onFilter &&
          this.props.onFilter(
            {
              rel: this.state.rel,
              cond: [],
            },
            true
          );
      }
    );
  };

  createFilterItem = (res) => {
    const { cond } = this.state;
    const find = cond.find((it) => {
      return it.field === res.widgetId;
    });
    return (
      <div className="filter-item bsy-filter-base" key={res.widgetId}>
        {/* <div
          className="remove-item"
          onClick={() => {
            this.deleteFilterItem(res);
          }}
        >
          <i className="icon-bsy-close-small"></i>
        </div> */}
        {find
          ? BsyUtils.createWidget({
              ...res,
              method: find.method,
              defaultConfig: this._margedefaultConfig(find, res.defaultConfig),
              getContext: this.getContext,
              onStopEdit: this.onFilterStopEdit,
            })
          : BsyUtils.createWidget({
              ...res,
              getContext: this.getContext,
              onStopEdit: this.onFilterStopEdit,
            })}
      </div>
    );
  };

  render() {
    const {
      hasRelation,
      fields,
      rel,
      hasPin,
      hasHeader,
      filterSticky,
      filterTopSticky,
      hasfilterTopSticky,
      hasfilterSticky,
      hasSticky,
    } = this.state;
    const { cssName } = this.options;
    let fieldsFilter = [];
    fields.map((res) => {
      if (res.name !== "label") {
        fieldsFilter.push(res);
      }
    });
    return (
      <div
        className={
          cssName +
          (filterTopSticky
            ? " filter-top-sticky"
            : filterSticky
            ? " filter-sticky"
            : "")
        }
        ref={this.element}
      >
        {hasSticky && (
          <>
            {hasfilterTopSticky && (
              <div
                className={
                  "pin-filter-top-sticky " + (filterTopSticky ? "sticky" : "")
                }
                onClick={() => {
                  if (window.FX && window.FX.UI) {
                    window.FX.UI.closePopover();
                  }
                  this.props.onFilterTopSticky &&
                    this.props.onFilterTopSticky();
                }}
              >
                <i className={"icon-bsy-top-sticky "}></i>
                <span>{React.language("pin.top")}</span>
              </div>
            )}
            {hasfilterSticky && (
              <div
                className={
                  "pin-filter-sticky " + (filterSticky ? "sticky" : "")
                }
                onClick={() => {
                  if (window.FX && window.FX.UI) {
                    window.FX.UI.closePopover();
                  }
                  this.props.onFilterSticky && this.props.onFilterSticky();
                }}
              >
                <i className={"icon-bsy-sticky "}></i>
                <span>{React.language("pin.right")}</span>
              </div>
            )}
          </>
        )}

        <div
          className={"pin-filter-close "}
          onClick={() => {
            if (window.FX && window.FX.UI) {
              window.FX.UI.closePopover();
            }
            this.props.onFilterClose && this.props.onFilterClose();
            this.props.context &&
              this.props.context.closeAlter &&
              this.props.context.closeAlter();
          }}
        >
          <i className={"icon-bsy-close-small "}></i>
        </div>
        {hasHeader ? (
          <div className="wrapper-title">
            <span className="title">{React.language("filter.condition")}</span>
            {hasRelation && filterTopSticky ? (
              <div className={"relation"}>
                <span className="rel-desc">
                  {React.language("filter.rel.tip")}
                </span>
                <BsySelect
                  theme={this.props.theme}
                  allowBlank={false}
                  searchable={false}
                  customCls={"cond-method"}
                  value={rel || "and"}
                  onStopEdit={(val) => {
                    this.setState({
                      rel: val,
                    });
                  }}
                  items={[
                    { value: "and", text: React.language("filter.rel.and") },
                    { value: "or", text: React.language("filter.rel.or") },
                  ]}
                />
                <span className="rel-desc">
                  {React.language("filter.rel.cond")}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {hasRelation && !filterTopSticky ? (
          <div className={"relation"}>
            <span className="rel-desc">{React.language("filter.rel.tip")}</span>
            <BsySelect
              theme={this.props.theme}
              allowBlank={false}
              searchable={false}
              customCls={"cond-method"}
              value={rel || "and"}
              onStopEdit={(val) => {
                this.setState({
                  rel: val,
                });
              }}
              items={[
                { value: "and", text: React.language("filter.rel.and") },
                { value: "or", text: React.language("filter.rel.or") },
              ]}
            />
            <span className="rel-desc">
              {React.language("filter.rel.cond")}
            </span>
          </div>
        ) : (
          ""
        )}

        <div className="pane">
          <div className="filter-list">
            {fields.map((field) => {
              return this.createFilterItem(field); //  BsyUtils.createWidget(field);
            })}
          </div>
        </div>

        <div className="footer">
          <BsyIconBtn
            text={React.language("filter")}
            mode={window.mode + " blue"}
            click={() => {
              this.props.onFilter && this.props.onFilter(this.getValue());
            }}
          />
          {/* <BsyIconBtn
            // iconName={'icon-clear'}
            text={React.language("clear")}
            mode={window.mode + " clear "}
            click={() => {
              this.reset();
            }}
          /> */}
        </div>
      </div>
    );
  }
}
